import { v4 } from "uuid"

export default function () {
    return {
        generate() {
            return v4()
        }
    }
}